export default theme => ({
  container: base => ({
    ...base,
    position: 'relative',
    marginRight: 0,
  }),
  control: base => ({
    ...base,
    borderRadius: 0,
    padding: '1px',
    border: '1px solid #d8d8d8',
    height: '50px',
    '&:hover': {
      boxShadow: '0 0'
    },
    '@media (min-width: 901px)': {
      padding: '6px',
    }
  }),
  indicatorSeparator: base => ({
    display: 'none'
  }),
  SingleValue: base => ({
    ...base,
    color: 'red'
  }),
  menu: base => ({
    ...base,
    zIndex: 499,
    //boxShadow: '0 4px 2px -2px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
    minHeight: '132px',
  }),
  menuList: base => {
    return {
      ...base,
      width: 'auto',
      overflowX: 'hidden',
      maxHeight: '132px',
      marginTop: '-8px',
    };
  },
  indicatorsContainer: base => {
    return {
      ...base,
      position: 'absolute',
      top: 0,
      right: -4,
      left: 'auto',
      bottom: 0,
      '&:lang(ar)': {
        right: 'auto',
        left: '-4px'
      },
    };
  },
  dropdownIndicator: base => ({
    ...base,
    color: theme,
    '&:hover': {
      color: theme
    }
  })
});
